module.exports = {"id":"210831","name":"Birger Verstraete","rating":"71","photo":"./data/images/photos/0/210831.png","club":{"name":"KAA La Gantoise","logo":"./data/images/clubs/KAALaGantoise.png"},"positions":["MDC","MC","DD"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/BirgerVerstraete0.json
// module id = 604
// module chunks = 0